// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-banner {
  position: relative;
  width: 100%;
  background-color: var(--brand-primary);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  z-index: 9999;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.update-banner-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.update-banner-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 6px;
}

.update-banner-text {
  font-size: 14px;
}

.update-banner-desc {
  opacity: 0.9;
  font-size: 13px;
}

.update-banner-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.update-banner-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.update-banner-close:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Force Update Overlay styles reuse from ForceUpdate.css but adjusted */
.force-update-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.force-update-card {
  background-color: var(--bg-1);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
}

.update-icon-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(239, 68, 68, 0.1);
  border-radius: 50%;
}

.update-icon-wrapper.mandatory {
  background-color: rgba(239, 68, 68, 0.1);
}

.update-icon-wrapper .warn-icon {
  color: #ef4444;
}

.update-icon-wrapper .sync-icon {
  position: absolute;
  bottom: -4px;
  right: -4px;
  background-color: var(--bg-1);
  color: var(--text-muted);
  border-radius: 50%;
  padding: 4px;
  width: 28px;
  height: 28px;
}

.update-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-normal);
  margin-bottom: 12px;
}

.update-desc {
  font-size: 15px;
  color: var(--text-muted);
  line-height: 1.5;
  margin-bottom: 32px;
}

.version-info-box {
  background-color: var(--bg-2);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.version-badge-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-label {
  font-size: 14px;
  color: var(--text-muted);
  font-weight: 500;
}

.version-badge {
  background-color: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

.version-badge.old {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.update-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn-large {
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateManager/UpdateManager.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".update-banner {\n  position: relative;\n  width: 100%;\n  background-color: var(--brand-primary);\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n  z-index: 9999;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.update-banner-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.update-banner-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  padding: 6px;\n}\n\n.update-banner-text {\n  font-size: 14px;\n}\n\n.update-banner-desc {\n  opacity: 0.9;\n  font-size: 13px;\n}\n\n.update-banner-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.update-banner-close {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.update-banner-close:hover {\n  color: white;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Force Update Overlay styles reuse from ForceUpdate.css but adjusted */\n.force-update-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.force-update-card {\n  background-color: var(--bg-1);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 40px;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\n}\n\n.update-icon-wrapper {\n  position: relative;\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(239, 68, 68, 0.1);\n  border-radius: 50%;\n}\n\n.update-icon-wrapper.mandatory {\n  background-color: rgba(239, 68, 68, 0.1);\n}\n\n.update-icon-wrapper .warn-icon {\n  color: #ef4444;\n}\n\n.update-icon-wrapper .sync-icon {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  background-color: var(--bg-1);\n  color: var(--text-muted);\n  border-radius: 50%;\n  padding: 4px;\n  width: 28px;\n  height: 28px;\n}\n\n.update-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-normal);\n  margin-bottom: 12px;\n}\n\n.update-desc {\n  font-size: 15px;\n  color: var(--text-muted);\n  line-height: 1.5;\n  margin-bottom: 32px;\n}\n\n.version-info-box {\n  background-color: var(--bg-2);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.version-badge-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.info-label {\n  font-size: 14px;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.version-badge {\n  background-color: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.version-badge.old {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.update-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.btn-large {\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
